import React from 'react';
import { GetStaticProps } from 'next';
import { SearchedProfileManager } from 'modules/App/server';
import HeaderLayout from 'modules/common/layouts/HeaderLayout';
import Hero from 'lib/components/ui/hero';
import { useAuthModal } from 'modules/auth';
import dbConnect from 'utils/db';
import MissionsList from 'modules/App/components/MissionsList';
import MissionsCities from 'modules/App/components/MissionsCities';
import { Section } from '@/lib/components/layout/section';
export interface MissionProps {
  missions: any[];
  cities: string[];
}

function Missions({ missions, cities }: MissionProps) {
  const { toggleModal } = useAuthModal();
  return (
    <HeaderLayout
      title={`${missions.length} offres d’emploi à pourvoir immédiatement`}
      description="Tu as un candidat parfait pour une de ces missions ? Propose-le en moins de 5 minutes, valorise ton travail déjà fourni et et récupère la prime."
    >
      <Hero
        title={
          <>
            <span className="text-primary">{missions.length}</span> offres d’emploi à pourvoir
            <br />
            <span className="">immédiatement</span>
          </>
        }
        description={
          <>
            Tu as le candidat parfait pour une de ces missions ?<br />
            <strong className="link link-primary" onClick={() => toggleModal()}>
              Inscris-toi
            </strong>
            , <strong>partage ton candidat</strong> et <strong>empoche la prime</strong>.
          </>
        }
      />
      <MissionsList missions={missions} />
      <Section className="bg-gray-50">
        <MissionsCities cities={cities} />
      </Section>
    </HeaderLayout>
  );
}

export const getStaticProps: GetStaticProps<MissionProps> = async () => {
  await dbConnect();
  const { items: missions, cities } = await SearchedProfileManager.listNotConnected();
  return {
    props: {
      missions: JSON.parse(JSON.stringify(missions)),
      cities: JSON.parse(JSON.stringify(cities.map((city) => city.slug))),
    },
  };
};

export default Missions;
